// apps/web/src/components/Security/RecoveryCodesWeb.jsx
import React, { useState } from 'react';
import api from '@mysimpledb/shared/config/axios';
import AppButton from '@mysimpledb/shared/components/UI/Button/Button';
import { toast } from 'react-hot-toast';

export default function RecoveryCodesWeb() {
  const [codes, setCodes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showRegenerate, setShowRegenerate] = useState(false);
  const [password, setPassword] = useState(null);
  const [disabling, setDisabling] = useState(false);

  async function confirmRecovery(e) {
    e?.preventDefault();
    console.log(password);
    if (!password) return;
    setDisabling(true);
    try {
      const { data } = await api.post('/twofa/recovery-codes/regenerate', {
        password,
      });
      setCodes(data.recoveryCodes);
      setShowRegenerate(false);
    } catch (e) {
      toast.error(e?.response?.data?.error ?? e?.message ?? String(e));
    } finally {
      setDisabling(false);
    }
  }

  function openRegenerate() {
    setPassword('');
    setShowRegenerate(true);
  }

  return (
    <>
      <section>
        <h2>Recovery Codes</h2>
        <p>
          Use a recovery code if you lose access to your authenticator app. Each
          code is one-time use.
        </p>
        <AppButton variant="solid" onPress={openRegenerate} disabled={loading}>
          {loading ? 'Generating…' : 'Generate New Codes'}
        </AppButton>
        {codes && (
          <pre
            style={{
              marginTop: 16,
              background: '#F9FAFB',
              padding: 12,
              borderRadius: 8,
            }}
          >
            {codes.join('\n')}
          </pre>
        )}
      </section>
      {showRegenerate && (
        <div
          style={backdropStyle}
          onClick={() => !disabling && setShowRegenerate(false)}
        >
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>Confirm disable</h3>
            <p>Enter your account password to generate recovery codes.</p>
            <form onSubmit={confirmRecovery}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                autoFocus
                style={inputStyle}
              />
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <button
                  type="submit"
                  disabled={!password || disabling}
                  style={primaryBtn}
                >
                  {disabling ? 'Regenerating…' : 'Regenerate'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowRegenerate(false)}
                  disabled={disabling}
                  style={ghostBtn}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

const backdropStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 50,
};
const modalStyle = {
  width: 'min(420px, 92vw)',
  background: '#fff',
  borderRadius: 12,
  padding: 16,
  boxShadow: '0 10px 30px rgba(0,0,0,.2)',
};
const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 8,
  border: '1px solid #d1d5db',
};
const primaryBtn = {
  background: '#ef4444',
  color: '#fff',
  border: 0,
  padding: '10px 14px',
  borderRadius: 8,
  cursor: 'pointer',
};
const ghostBtn = {
  background: 'transparent',
  border: '1px solid #d1d5db',
  padding: '10px 14px',
  borderRadius: 8,
  cursor: 'pointer',
};
